/* Pause Parfumée – scripts communs.
   1. Ajout au panier depuis les cartes et les suggestions (panier latéral du thème).
   2. Compléments du panier latéral : jauge livraison offerte, suggestions, code promo. */
(function () {
  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function cartDrawer() { return document.querySelector('cart-drawer'); }

  /* Envoie une modification au panier puis redessine le panier latéral */
  function cartRequest(path, body) {
    var cart = cartDrawer();
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (section) { return section.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch(rootUrl() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) { return response.json(); });
  }
  function renderCart(state) {
    var cart = cartDrawer();
    if (cart && typeof cart.renderContents === 'function' && state.sections) {
      cart.classList.remove('is-empty');
      cart.renderContents(state);
      return true;
    }
    return false;
  }

  /* 1. Ajout au panier */
  function addToCart(button) {
    var variantId = button.getAttribute('data-pp-add');
    if (!variantId || button.disabled) return;
    var label = button.innerHTML;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    cartRequest('cart/add.js', { id: Number(variantId), quantity: 1 })
      .then(function (state) {
        if (state.status) {
          button.textContent = state.description || state.message || 'Indisponible';
          return;
        }
        if (!renderCart(state)) {
          window.location.href = rootUrl() + 'cart';
          return;
        }
        // Prévient le reste du thème (compteur, panier) qu'un article a été ajouté.
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pp-card', productVariantId: variantId, cartData: state });
        }
        button.textContent = 'Ajouté';
        setTimeout(function () { button.innerHTML = label; }, 2000);
      })
      .catch(function () { window.location.href = rootUrl() + 'cart'; })
      .finally(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-pp-add]');
    if (!button) return;
    event.preventDefault();
    addToCart(button);
  });

  /* 2. Compléments du panier latéral */
  var pendingMessage = '';
  var loading = false;

  function placeParts(html) {
    var cart = cartDrawer();
    if (!cart || cart.classList.contains('is-empty')) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var spots = {
      style: function (node) { cart.appendChild(node); },
      bar: function (node) {
        var header = cart.querySelector('.drawer__header');
        if (header) header.insertAdjacentElement('afterend', node);
      },
      suggest: function (node) {
        // Dans la zone qui défile, sous les produits du panier.
        var items = cart.querySelector('cart-drawer-items');
        if (items) items.appendChild(node);
      },
      discount: function (node) {
        var footer = cart.querySelector('.drawer__footer');
        if (footer) footer.insertAdjacentElement('afterbegin', node);
      },
      ship: function (node) {
        // Juste au-dessus du total
        var totals = cart.querySelector('.drawer__footer .totals');
        if (totals) totals.insertAdjacentElement('beforebegin', node);
      }
    };
    Object.keys(spots).forEach(function (name) {
      var fresh = doc.querySelector('[data-pp-cart-part="' + name + '"]');
      var old = cart.querySelector('[data-pp-cart-part="' + name + '"]');
      if (!fresh) return;
      if (old) old.replaceWith(fresh); else spots[name](fresh);
    });
    var msg = cart.querySelector('[data-pp-discount-msg]');
    if (msg && pendingMessage) { msg.textContent = pendingMessage; pendingMessage = ''; }
  }

  function refreshParts() {
    var cart = cartDrawer();
    if (!cart || loading) return;
    loading = true;
    fetch(rootUrl() + '?sections=pp-cart-extras')
      .then(function (r) { return r.json(); })
      .then(function (data) { if (data && data['pp-cart-extras']) placeParts(data['pp-cart-extras']); })
      .catch(function () {})
      .finally(function () { loading = false; });
  }

  function partsMissing() {
    var cart = cartDrawer();
    return cart && !cart.classList.contains('is-empty') && cart.querySelector('.drawer__header') && !cart.querySelector('#CartDrawer [data-pp-cart-part="bar"]');
  }

  function watchDrawer() {
    var cart = cartDrawer();
    if (!cart) return;
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () { if (partsMissing()) refreshParts(); }, 120);
    }).observe(cart, { childList: true, subtree: true });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refreshParts, 150); });
    }
    if (partsMissing()) refreshParts();
  }

  /* Code promo */
  function sameCode(a, b) { return a.toLowerCase() === b.toLowerCase(); }

  /* add : code à ajouter ; remove : code à retirer. Les autres codes valides sont conservés. */
  function applyDiscount(add, remove) {
    var input = document.getElementById('PpDiscountCode');
    if (input) input.disabled = true;
    fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (current) {
        var codes = (current.discount_codes || [])
          .filter(function (d) { return d.applicable && !(remove && sameCode(d.code, remove)) && !(add && sameCode(d.code, add)); })
          .map(function (d) { return d.code; });
        if (add) codes.push(add);
        return cartRequest('cart/update.js', { discount: codes.join(',') });
      })
      .then(function (state) {
        if (!add) {
          pendingMessage = 'Code retiré.';
          return state;
        }
        var found = (state.discount_codes || []).filter(function (d) { return sameCode(d.code, add); })[0];
        if (found && found.applicable) {
          pendingMessage = 'Code appliqué.';
          return state;
        }
        pendingMessage = 'Ce code ne s\'applique pas à ton panier.';
        // On retire le code refusé et on garde ceux qui fonctionnent.
        var kept = (state.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
        return cartRequest('cart/update.js', { discount: kept.join(',') });
      })
      .then(function (state) { if (!renderCart(state)) window.location.reload(); })
      .catch(function () { pendingMessage = 'Le code n\'a pas pu être appliqué. Réessaie dans un instant.'; refreshParts(); });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-pp-discount-form]');
    if (!form) return;
    event.preventDefault();
    var code = (form.querySelector('input[name="discount"]').value || '').trim();
    if (code) applyDiscount(code, '');
  });
  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-pp-discount-remove]');
    if (remove) {
      event.preventDefault();
      applyDiscount('', remove.getAttribute('data-pp-discount-remove'));
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer);
  else watchDrawer();
})();
